import React from 'react';

import { Box, Grid, Icon, useMediaQuery, useTheme } from '@mui/material';
import { common } from '@mui/material/colors';
import workbuzzLogo from 'app/asset/workbuzz_logo.svg';
import { AddReviewContent } from 'component/AddReviewContent/AddReviewContent';

import {
  addReviewContentStyles,
  contentStyles,
  contentWrapperStyles,
  feedbackContentMobileStyles,
  feedbackWrapperMobileStyles,
  logoStyles,
  rightColumnInnerStyles,
  rightColumnStyles,
} from './PageWrapperWithFeedback.s';

export const PageWrapperWithFeedback: React.FC<React.PropsWithChildren> = ({ children }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Grid container data-testid="pageWrapperWithFeedback">
      <Grid item sx={{ width: { xs: '100%', lg: '50%' }, minWidth: { xs: '100%', lg: '50%' } }}>
        <Box component="img" src={workbuzzLogo} alt="WorkBuzz" sx={logoStyles} />
        <Box sx={contentWrapperStyles}>
          <Box sx={contentStyles}>{children}</Box>
        </Box>
        {!isDesktop && (
          <Box sx={feedbackWrapperMobileStyles} data-testid="feedbackWrapperMobile">
            <Box sx={feedbackContentMobileStyles}>
              <Icon sx={{ color: common.white }}>keyboard_arrow_up</Icon>
              <AddReviewContent />
            </Box>
          </Box>
        )}
      </Grid>
      {isDesktop && (
        <Grid
          item
          sx={{ ...rightColumnStyles, width: '50%', minWidth: '50%' }}
          data-testid="rightColumn"
        >
          <Box sx={rightColumnInnerStyles}>
            <AddReviewContent sx={addReviewContentStyles} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};
